function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "Suitcase");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Suitcase",
  transform: "translate(0.000000, 0.050000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5,3.75 L15,3.75 L15,1.875 C15,0.841015577 14.1601562,0 13.125,0 L6.875,0 C5.83984375,0 5,0.841015577 5,1.875 L5,3.75 L2.5,3.75 C1.11914039,3.75 0,4.87109423 0,6.25 L0,16.25 C0,17.6308596 1.11914039,18.75 2.5,18.75 L17.5,18.75 C18.8808596,18.75 20,17.6308596 20,16.25 L20,6.25 C20,4.87109423 18.8789058,3.75 17.5,3.75 Z M6.25,1.875 C6.25,1.53007746 6.53124988,1.25 6.875,1.25 L13.125,1.25 C13.4687495,1.25 13.75,1.53007746 13.75,1.875 L13.75,3.75 L6.25,3.75 L6.25,1.875 Z M3.75,17.5 L2.5,17.5 C1.81093752,17.5 1.25,16.9390631 1.25,16.25 L1.25,6.25 C1.25,5.56093693 1.81093752,5 2.5,5 L3.75,5 L3.75,17.5 Z M15,17.5 L5,17.5 L5,5 L15,5 L15,17.5 Z M18.75,16.25 C18.75,16.9390631 18.1890631,17.5 17.5,17.5 L16.25,17.5 L16.25,5 L17.5,5 C18.1890631,5 18.75,5.56093693 18.75,6.25 L18.75,16.25 Z",
  id: "Shape"
})));
const SvgIconSuitcase = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSuitcase, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-suitcase.1a1bf9ae.svg";
export { ForwardRef as ReactComponent };